module.exports = __webpack_public_path__ + "static/media/ossi.pietiläinen.b735db44.jpg";